export default __webpack_public_path__ + "static/media/homePic.4e14047d.jpeg";